import { BaseSerializer } from '/src/app/core/serializers/baseSerializer';

class StatsSerializer extends BaseSerializer {
  deserialize(raw) {
    const success = raw?.statusCode == 200 || raw?.id;

    const mockStats = {
      totalTransactions: 12,
      totalSpent: 45000,
      activeSubscriptions: 3,
      pendingTransactions: 1,
    };

    return {
      success,
      data: mockStats
    };
  }

  serialize(data) {
    return null;
  }
}

export const statsSerializer = new StatsSerializer();
